// Modulos que o `datatable_controller` sabe montar. Cada um exporta
// `load(element)` e devolve a Api do DataTables. O `import()` deixa o codigo de
// cada tela num chunk proprio (~8 KB); o DataTables em si ja vem no pack
// `application`. O `load()` nao deve depender do DOM ready de outros modulos:
// o que ele precisa (selectize, `deferLoading`) declara ele mesmo.
//
// Substitui, modulo a modulo, o `switch` de `packs/datatables/default.js`
// (#1076-#1078).
export default {
  cte_xmls: () => import('./cte_xmls'),
  nfe_xmls: () => import('./nfe_xmls'),
};
